//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"LineColor",1,0],[0,"MajorLineSpacing",1,0],[0,"MajorLineStyle",1,0],[0,"MajorLineWeight",1,0],[0,"MinorLineStyle",1,0],[0,"MinorLineWeight",1,0],[0,"MinorLinesPerMajor",1,0],[0,"Show",1,0],[0,"ShowMajorLines",1,0],[0,"ShowOnTop",1,0],[0,"SnapPointsPerMinor",1,0],[0,"SnapToGrid",1,0]],[[["grid"],"InheritSettings",{},1,0]],[]];
SPLM.Display.GridBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.GridBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.GridBuilder.LineStyleType = Object.freeze({
    "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "Longdash" : "Longdash", "Dotdash" : "Dotdash", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Display.GridBuilder.LineWeightType = Object.freeze({
    "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

export default SPLM;